import React from 'react';
import { Text, Tooltip } from '@amzn/storm-ui';

export const ActionsText: React.VFC<{
  label: string;
  toolTip?: string;
  id: string;
}> = ({ label, toolTip, id }) => {
  const text = (
    <Text id={id} data-ccx-e2e-id={`aac-action-${id}`}>
      {label}
    </Text>
  );

  return toolTip && toolTip.length > 0 ? (
    <Tooltip
      id={id}
      trigger={text}
      message={toolTip}
      data-ccx-e2e-id={`aac-action-${id}`}
    />
  ) : (
    text
  );
};
